import { __decorate } from "tslib";
import { AsnType, AsnTypeTypes, AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
export const id_osVersion = "1.3.6.1.4.1.311.13.2.3";
let AnyString = class AnyString {
    constructor(params = {}) {
        Object.assign(this, params);
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.NumericString })
], AnyString.prototype, "numericString", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.PrintableString })
], AnyString.prototype, "printableString", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.TeletexString })
], AnyString.prototype, "teletexString", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.VideotexString })
], AnyString.prototype, "videotexString", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String })
], AnyString.prototype, "ia5String", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.GraphicString })
], AnyString.prototype, "graphicString", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.VisibleString })
], AnyString.prototype, "visibleString", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.GeneralString })
], AnyString.prototype, "generalString", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.UniversalString })
], AnyString.prototype, "universalString", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.BmpString })
], AnyString.prototype, "bmpString", void 0);
AnyString = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], AnyString);
export { AnyString };
